import i18n from "./config";

export const getLocaleString = (key, secondaryString, args_dict = {}) => {
  if (i18n.exists(key)) {
    return i18n.t(key, args_dict);
  } else if (secondaryString) {
    // Apply the same {{variable}} interpolation that i18n.t() would apply,
    // so fallback strings work correctly when locale keys are not yet defined.
    return Object.keys(args_dict).reduce(
      (str, k) =>
        str.replace(
          new RegExp(`\\{\\{${k}\\}\\}`, "g"),
          args_dict[k] != null ? args_dict[k] : ""
        ),
      secondaryString
    );
  } else {
    return key || "";
  }
};
